import { AutorenewIcon } from './AutorenewIcon';

/**
 * author: Google
 * id 00598C19-1255-479D-914A-1AADFDBC4868
 * name autorenew
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/autorenew.svg
 * tags
 * - Arrow 
 */
export const ClockwiseArrowsIcon = AutorenewIcon;
export default ClockwiseArrowsIcon